/**
 * Docked banner variant for the Anon connection page — pure derivation,
 * extracted from AnonConnectionPage's render body (refactor log, 2026-07-04:
 * unit-testable + portable where an inline state machine was neither).
 *
 * Rules:
 * - Terminal states suppress prompts entirely (deleted connection).
 * - A real-access invite from the Profile shows unless permanently dismissed.
 *
 * @returns {'invite'|null}
 */
export const deriveBannerVariant = ({ dotStatus, inviteMsg, userPreferences }) => {
  if (dotStatus === 'deleted') return null;
  if (inviteMsg && !userPreferences?.inviteBannerDismissed) return 'invite';
  return null;
};

/**
 * Whether to dock the WelcomeInviteBanner, given the exchange variant.
 *
 * Non-THREAD always mounts it (the component self-hides on a null variant and
 * slides out on dismiss). THREAD is banner-free EXCEPT a real invite: the
 * docked banner is the invited guest's ONLY path to PWA sign-up, so suppressing
 * it unconditionally silently killed invite conversion when THREAD became
 * main's default (regression ef396ceb2, 2026-08-15). Returning null here (vs.
 * always mounting) keeps THREAD's non-invite state free of an empty footer gap.
 *
 * @param {{ isThread: boolean, bannerVariant: ('invite'|null) }} args
 * @returns {boolean}
 */
export const shouldDockBanner = ({ isThread, bannerVariant }) =>
  !isThread || bannerVariant === 'invite';
